/* jshint unused: false */



// -------------------------------------------------------
// Helper Functions
// -------------------------------------------------------

// Credit David Walsh (https://davidwalsh.name/javascript-debounce-function)

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.

function awUserLoggedInEvent() {
    const userLoggedInEvent = new CustomEvent('userLoggedIn', {
        bubbles: true,
        cancelable: false,
    });
    let userData = awGetUserData();
    if( userData ){
        document.dispatchEvent(userLoggedInEvent);
    }
}
window.awUserLoggedInEvent = awUserLoggedInEvent;

function debounce(func, wait, immediate) {
    var timeout;

    return function executedFunction() {
        var context = this;
        var args = arguments;

        var later = function() {
            timeout = null;
            if (!immediate){
                func.apply(context, args);
            }
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if (callNow){
            func.apply(context, args);
        }
    };
}

window.debounce = debounce;

function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

window.isEmail = isEmail;



/**
 * Parse the query string.
 * @param {string} name - The name of the query string parameter to retrieve
 * @param {string} url - The URL to parse. Defaults to window.location.href
 * @see https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
 */
function getParameterByName(name, url = window.location.href) {
    try {
        const params = new URL(url, window.location.href).searchParams;
        return params.has(name) ? params.get(name) : null;
    } catch (err) {
        return null;
    }
}

window.getParameterByName = getParameterByName;

// Remove query string by name

function removeParam( url, param ) {
    if ( url && param && url.indexOf('?') !== -1 ){
        var urlBase = url.substring( 0, url.indexOf( '?' ) ),
            params = url.split( /&|\?/ ),
            keepParams = [];

        params.shift();

        for ( var i=0; i < params.length; i++ ){
            var paramKeyNamePair = params[i].split( '=' );
            if ( paramKeyNamePair.length ){
                var paramName = paramKeyNamePair[0];
                if ( params[i].indexOf( param ) === 0 && param.length === paramName.length ){
                    /* noop */
                } else {
                    keepParams.push( params[i] );
                }
            }
        }
        url = urlBase + '?' + keepParams.join('&');
    }
    return url;
}

window.removeParam = removeParam;

// Add query string to URL, or update if it already exists

function addUrlParam( url, key, value ) {
    var key = encodeURIComponent(key),
        value = encodeURIComponent(value);

    var baseUrl = url.split('?')[0],
        newParam = key + '=' + value,
        params = '?' + newParam,
        urlQueryString;

    if (url.split('?')[1] === undefined){ // if there are no query strings, make urlQueryString empty
        urlQueryString = '';
    } else {
        urlQueryString = '?' + url.split('?')[1];
    }

    // If the "search" string exists, then build params from it
    if (urlQueryString) {
        var updateRegex = new RegExp('([\?&])' + key + '=[^&]*');
        var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');

        if (value === undefined || value === null || value === '') { // Remove param if value is empty
            params = urlQueryString.replace(removeRegex, "$1");
            params = params.replace(/[&;]$/, "");
    
        } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
            params = urlQueryString.replace(updateRegex, "$1" + newParam);
    
        } else if (urlQueryString == '') { // If there are no query strings
            params = '?' + newParam;
        } else { // Otherwise, add it to end of query string
            params = urlQueryString + '&' + newParam;
        }
    }

    // no parameter was set so we don't need the question mark
    params = params === '?' ? '' : params;

    return baseUrl + params;

    if ( url.indexOf( param ) === -1 ){
        return `${url}${ url.indexOf( '?' ) === -1 ? '?' : '&' }${param}=${value}`;
    } else{

    }
}

window.addUrlParam = addUrlParam;

// Wait for a global variable to be defined.
// https://github.com/OwenMelbz/whendefined
/*
    Example: waiting for a variable helloWorld

    whenDefined(window, 'helloWorld', function() {
        alert( 'hello!' );
    });
*/

function whenDefined( context, variable, callback ) {
    if ( context[variable] ) {
        callback();
    } else {
        Object.defineProperty( context, variable, {
            configurable: true,
            enumerable: true,
            writeable: true,
            get: function() {
                return this['_' + variable];
            },
            set: function( val ) {
                this['_' + variable] = val;
                callback();
            }
        } );
    }
}

window.whenDefined = whenDefined;

function awIsOnScreen( elem ) {
    // https://gist.github.com/EvanHerman/a1045c19e115edc18b12
    if( elem.length == 0 ) {
        return;
    }
    var $window = jQuery(window)
    var viewport_top = $window.scrollTop()
    var viewport_height = $window.height()
    var viewport_bottom = viewport_top + viewport_height
    var $elem = jQuery(elem)
    var top = $elem.offset().top
    var height = $elem.height()
    var bottom = top + height

    return (top >= viewport_top && top < viewport_bottom) ||
        (bottom > viewport_top && bottom <= viewport_bottom) ||
        (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}

window.awIsOnScreen = awIsOnScreen;

function awRedirectWithParameters( params ){

    console.log( 'awRedirectWithParameters called' );
    let url = window.location.href;

    for ( var key in params ) {
        if ( url.indexOf( '?' ) === -1 ){
            url += '?';
        } else {
            url += '&';
        }

        if ( params.hasOwnProperty( key ) ) {
            url += key + '=' + params[key];
        }
    }

    window.location = url;
}

window.awRedirectWithParameters = awRedirectWithParameters;
	
function getBlaizeData (){
	 return $.ajax({ url: '/blaize/account',type: 'GET',});
}

function awGetUserData(){
	let userData = localStorage.getItem("aw_udata");
	try{
		if(userData) {
		userData = JSON.parse(atob(userData));
		if (typeof userData === 'object')
				userData = JSON.parse( atob( userData.user_data ));
			else 
				userData = {};
		}else{
			userData = {};
		}
    } catch( err ){ /* noop */ }
    
    return userData;
}

window.awGetUserData = awGetUserData;

function awUpdateUserData( fields ){
    let userData = awGetUserData();

    if ( userData ){
        for ( var key in fields ) {
            if ( fields.hasOwnProperty( key ) ) {
                userData[key] = fields[key];
            }
        }
    }
    localStorage.setItem( 'aw_udata', window.btoa( JSON.stringify( userData ) ) );
    return userData;
}

window.awUpdateUserData = awUpdateUserData;

function awGetShadowUserData(){
    let userData = {};

    try{
      userData = JSON.parse( atob( localStorage.getItem( 'aw_udata_s' ) ) );
    } catch( err ){ /* noop */ }

    return userData;
}

window.awGetShadowUserData = awGetShadowUserData;

function awUpdateShadowUserData( fields ){
    let userData = {};

    if ( !window.awIsUserLoggedIn() ){
        userData = awGetShadowUserData();

        if ( userData ){
            for ( var key in fields ) {
                if ( fields.hasOwnProperty( key ) ) {
                    userData[key] = fields[key];
                }
            }
        }
		
        localStorage.setItem( 'aw_udata', window.btoa( JSON.stringify( userData ) ) );
    }
    return userData;
}

window.awUpdateShadowUserData = awUpdateShadowUserData;

function awGetUserCookie(){
    let userData = {};

    try{
		
		const localStorageData = JSON.parse(atob(localStorage.getItem("aw_udata")));
		
		
		if (typeof localStorageData === 'object')
			userData =  JSON.parse(atob(localStorageData.user_cookie));
		else 
			userData = {};
       // userData = JSON.parse( atob( zephr_user_object.user_cookie ) );
    } catch( err ){ /* noop */ }

    return userData;
}

window.awGetUserCookie = awGetUserCookie;

function awDeleteUserData(){
    localStorage.removeItem( 'aw_udata' )
}

window.awDeleteUserData = awDeleteUserData;

function awDeleteUserCookie( reloadPage ){
    try{
        Cookies.remove( aw.user_cookie_name );
        if ( reloadPage ){
            location.reload();
        }
    } catch( err ){ /* noop */ }
}

window.awDeleteUserCookie = awDeleteUserCookie;


function awIsUserLoggedIn(){
    let isLoggedIn = false;
    // Remove cookie handle for Blogs
    let zephr_login_cookie = Cookies.get('zephr_login');
    if ( typeof Zephr !== 'undefined' ){
        isLoggedIn = Zephr.accessDetails.isAuthenticated;
        if( zephr_login_cookie ){
            Cookies.remove( 'zephr_login' );
        }     
    }

    /* const userData = awGetUserData();
    const userCookie = awGetUserCookie();
		
    if ( !userData || !userCookie || jQuery.isEmptyObject( userData ) || jQuery.isEmptyObject( userCookie ) ){
        isLoggedIn = false;
    } */

    const eventLoginCheck = new Event( 'loginCheck' );

    window.dispatchEvent( eventLoginCheck );

    return isLoggedIn;
	

}

window.awIsUserLoggedIn = awIsUserLoggedIn;

function awIsCMSLoggedIn(){
    return jQuery( 'body' ).hasClass( 'logged-in' );
}

window.awIsCMSLoggedIn = awIsCMSLoggedIn;

function awIsMobile(){
    var isMobile = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) isMobile = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return isMobile;
}

window.awIsMobile = awIsMobile;

window.awIsTablet = function(){
    let isTablet = false;

    if ( navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 ){
        isTablet = true;
    } else {
        const userAgent = navigator.userAgent.toLowerCase();
        isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
    }

    return isTablet;    
}

function awGetRdt(){
    return window.getParameterByName( 'rdt' ) || Cookies.get('aw_rdt_url') || ( window.location.protocol + '//' + window.location.hostname ) || 'https://adweek.com';
}

window.awGetRdt = awGetRdt;

function awCopyToClipboard( str ){
    const el = document.createElement( 'textarea' );
    el.value = str;
    el.setAttribute( 'readonly', '' );
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild( el );
    el.select();
    document.execCommand( 'copy' );
    document.body.removeChild( el );
}

window.awCopyToClipboard = awCopyToClipboard;

function awAppendQuestionmarkOrAmpersand( str ){
    return str + ( str.indexOf( '?' ) === -1 ? '?' : '&'  );
}

window.awAppendQuestionmarkOrAmpersand = awAppendQuestionmarkOrAmpersand;

function awReplaceAccents(str) {
    // verifies if the String has accents and replace them
    if (str.search(/[\xC0-\xFF]/g) > -1) {
        str = str
            .replace( /[\xC0-\xC5]/g, 'A' )
            .replace( /[\xC6]/g, 'AE' )
            .replace( /[\xC7]/g, 'C' )
            .replace( /[\xC8-\xCB]/g, 'E' )
            .replace( /[\xCC-\xCF]/g, 'I' )
            .replace( /[\xD0]/g, 'D' )
            .replace( /[\xD1]/g, 'N' )
            .replace( /[\xD2-\xD6\xD8]/g, 'O' )
            .replace( /[\xD9-\xDC]/g, 'U' )
            .replace( /[\xDD]/g, 'Y' )
            .replace( /[\xDE]/g, 'P' )
            .replace( /[\xE0-\xE5]/g, 'a' )
            .replace( /[\xE6]/g, 'ae' )
            .replace( /[\xE7]/g, 'c' )
            .replace( /[\xE8-\xEB]/g, 'e' )
            .replace( /[\xEC-\xEF]/g, 'i' )
            .replace( /[\xF1]/g, 'n' )
            .replace( /[\xF2-\xF6\xF8]/g, 'o' )
            .replace( /[\xF9-\xFC]/g, 'u' )
            .replace( /[\xFE]/g, 'p' )
            .replace( /[\xFD\xFF]/g, 'y' ) ;
    }

    return str;
}

window.awReplaceAccents = awReplaceAccents;

function awRemoveNonWord(str) {
    return str.replace( /[^0-9a-zA-Z\xC0-\xFF \-]/g, '' );
}

window.awRemoveNonWord = awRemoveNonWord;

function awSlugify( str, delimeter ) {
    if ( !delimeter ) {
        delimeter = '-';
    }
    str = awReplaceAccents( str );
    str = awRemoveNonWord( str );
    str = str.trim()
        .replace( / +/g, delimeter )
        .toLowerCase();
    return str;
}

window.awSlugify = awSlugify;

function awToLowercaseAndDashes( str ){
    return str.replace(/\s+/g, '-').toLowerCase();
}
window.awToLowercaseAndDashes = awToLowercaseAndDashes;


( function( $ ) {
    $.holdReady( false );
} )( jQuery );

if( window.aw ){
    window.awLoggedIn = Cookies.get( aw.user_cookie_name ) ? true : false;
}

function awGetUserType(){
    if ( awGetUserData() ) {
        return awGetUserData().sub_type;
    }
}

window.awGetUserType = awGetUserType;

function awGetCountryInfo( countryNameOrCode ){
    let userCountry = {};

    for ( let i = 0; i < aw.countries.length; i++ ) {
        if ( countryNameOrCode === aw.countries[i].code_alpha_2 ||
             countryNameOrCode === aw.countries[i].code_cw ||
             aw.countries[i].names.indexOf( countryNameOrCode ) !== -1
        ){
            userCountry = aw.countries[i];
            break;
        }
    }

    return userCountry;
}

window.awGetCountryInfo = awGetCountryInfo;

function awGetUserCurrentTypePaid(){
    if (awGetUserData()) {
        if(awGetUserData().curr_type!=='QN'){
            return true;
        } else {
            return false;
        };
    }
}

window.awGetUserCurrentTypePaid = awGetUserCurrentTypePaid;

function awGetFileNameFromUrl( url ){
    return url.split('/').pop();
}

window.awGetFileNameFromUrl = awGetFileNameFromUrl;

function awValidateForm( form, cb ){
    if ( !form || !cb ){
        return false;
    }

    let $form = jQuery( form );
    let $formFields = $form.find( ':input' );
    let errorMsg = null;

    $formFields.each( function(){
        let $field = jQuery( this ),
            isRequired = !!$field.attr( 'required' ),
            fieldValue = $field.val() ? $field.val().trim() : '',
            fieldType = $field.attr( 'type' );
            fieidId = $field.attr('id');

        if ( isRequired && fieldValue.length === 0 ){
            errorMsg = 'missing_required_value';
            cb( errorMsg );
            return false;
        }

        if( fieldValue && fieidId === 'aw_reg_email' ) {
            if( !window.isEmail( $field.val() ) || $field.val().length > 50 ) {
                errorMsg = 'email_format'
                cb( errorMsg );
                return false;
            }
        }

        if ( fieldType === 'tel' && fieldValue ){
            const phoneNumberPattern = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
            if ( !phoneNumberPattern.test( fieldValue ) ){
                errorMsg =  'phone_number_format';
                cb( errorMsg );
                return false;
            }
        }
    } );

    if ( ($form.find('#aw_reg_job_industry').val() && 
        $form.find('#aw_reg_job_industry').val() === '54' && 
        $form.find('#aw_reg_job_industry_other').val().length === 0 ) || 
        ($form.find('#aw_reg_job_department').val() && 
        $form.find('#aw_reg_job_department').val() === '26' && 
        $form.find('#aw_reg_job_department_other').val().length === 0 ) || 
        ($form.find('#aw_reg_job_level').val() && 
        $form.find('#aw_reg_job_level').val() === '23' && 
        $form.find('#aw_reg_job_level_other').val().length === 0 )){
            errorMsg = 'missing_required_value';
            cb( errorMsg );
            return false;
    }
    if ( !errorMsg ){
        cb( null );
    }
}

window.awClearForm = function ( $form ){
    if ( $form && $form.length && $form.trigger ){
        $form.trigger( 'reset' );
    }
}

window.awConvertUserData = function( userData ){
    /* Convert user data from forms that uses non-C&W values */
    try{

        if ( userData['bcode'] && userData['bcode'].length && userData['bcode'].length > 3 ){
            window.aw.businessTypes.forEach( function( businessType ){
                if ( userData['bcode'].toLowerCase() === businessType.title.toLowerCase() ){
                    userData['bcode'] = businessType.code;
                }
            } );
        }

        if ( userData['btitle'] && userData['btitle'].length && userData['btitle'].length > 3 ){
            window.aw.jobLevels.forEach( function( jobLevel ){
                if ( userData['btitle'].toLowerCase() === jobLevel.title.toLowerCase() ){
                    userData['btitle'] = jobLevel.code;
                }
            } );
        }

        if ( userData['job_function'] && userData['job_function'].length && userData['job_function'].length > 3 ){
            window.aw.jobDepartments.forEach( function( jobDepartment ){
                if ( userData['job_function'].toLowerCase() === jobDepartment.title.toLowerCase() ){
                    userData['job_function'] = jobDepartment.code;
                }
            } );
        }

        window.aw.jobDepartments.forEach( function( jobDepartment ){
            if ( userData['job_function'].toLowerCase() === jobDepartment.title.toLowerCase() ){
                userData['job_function'] = jobDepartment.code;
            }
        } );

        let awUserCountry = window.awGetCountryInfo( userData['country'] );

        userData['country'] = awUserCountry.code_alpha_2;
        userData['country_code'] = awUserCountry.code_cw;
    } catch( err ){
        /* noop */
    }
    return userData;
}
window.awValidateForm = awValidateForm;

function awChangeTimeZone(date, timeZone) {
    if (typeof date === 'string') {
        return new Date(
            new Date(date).toLocaleString('en-US', {
                timeZone,
            }),
        );
    }
    return new Date(
        date.toLocaleString('en-US', {
            timeZone,
        }),
    );
}
window.awChangeTimeZone = awChangeTimeZone;

function awCalculateArticleTime(postPublishUnixTimestamp) {
    var postDate = new Date(postPublishUnixTimestamp * 1000);
    var currDate = new Date();
    var currDateEst = awChangeTimeZone(currDate, 'America/New_York');
    var postDateEst = awChangeTimeZone(postDate, 'America/New_York');
    var currDateEst = new Date(currDateEst);
    var postDateEst = new Date(postDateEst);
    var seconds = (currDateEst.getTime() - postDateEst.getTime()) / 1000;
    seconds = Math.round(seconds);
    var minutes = seconds / 60;
    minutes = Math.round(minutes);

    var hours = minutes / 60;
    hours = Math.round(hours);

    var months = new Array(12);
    months[0] = "January";
    months[1] = "February";
    months[2] = "March";
    months[3] = "April";
    months[4] = "May";
    months[5] = "June";
    months[6] = "July";
    months[7] = "August";
    months[8] = "September";
    months[9] = "October";
    months[10] = "November";
    months[11] = "December";

    var monthValue = postDateEst.getMonth();
    var dayValue = postDateEst.getDate();
    var yearValue = postDateEst.getFullYear();

    postDateEst =  months[monthValue] + " " + dayValue + ", " + yearValue;
    var postDateOutput = postDateEst;
 
    if(seconds < 0){
        postDateOutput = "Few seconds ago";
    }else if(seconds < 60){
        seconds = String(seconds).substring(0, 2);
        postDateOutput = seconds + " seconds ago";
    }else if(minutes < 60){
        minutes = String(minutes).substring(0, 2);
        postDateOutput = minutes + " mins ago";
    }else if(hours < 24){
        postDateOutput = hours  + " hours ago";
    } else {
        postDateOutput = postDateEst;
    }
    return postDateOutput;
}
window.awCalculateArticleTime = awCalculateArticleTime;

function awUpdateArticleTimeOnCategoryPage() {
    const category = document.getElementsByClassName("category");
    if(category.length){
        const publishTime = document.getElementsByClassName('custom-publish-time');
        if(publishTime){
            for(let i=0; i<publishTime.length; i++){
                let postPublishUnixTimestamp = publishTime[i].getAttribute("data-published-time");
                let postTimeOutput = awCalculateArticleTime(postPublishUnixTimestamp);
                publishTime[i].innerHTML = postTimeOutput;
            }
        }
    }
}
window.awUpdateArticleTimeOnCategoryPage = awUpdateArticleTimeOnCategoryPage;